import styled from "styled-components";
import Variables from "../../styles/Variables";


export const EventSeatsMapContainer = styled.div`
	min-width: 300px;
	padding: 10px 24px;
`

export const EventDatesTitleContainer = styled.div`
	display: flex;
	gap: 6px;
	flex-direction: column;
	padding: 20px 0;
`

export const EventDatesTitle = styled.h3`
	font-size: 24px;
	font-weight: bold;
`

export const EventDatesSubtitle = styled.span`
	font-size: 14px;
	color: #757575;
`

export const EventSeatsMapRef = styled.div`
	margin-top: 20px;
	margin-bottom: 60px;
	width: 100%;
	height: 550px;
	position: relative;
	background-color: white;
	border-radius: 8px 8px 0 0;
	box-shadow: ${Variables.boxShadows.level1};
`

export const EventSeatsContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
`

export const EventSeatsMobileNavBar = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	background-color: ${Variables.backgrounds.light};
	box-shadow: ${Variables.boxShadows.level1};
	width: 100%;
	z-index: 999;
	padding: 20px 10px;
`

export const NavBarContent = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
`

export const NavIconContainer = styled.div`
	position: absolute;
	left: 18px;
`

export const NavTitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	flex: 1;
	align-items: center;
`

export const NavTitle = styled.h3`
	font-weight: bold;
	font-size: 18px;
`
export const NavEventTitle = styled.span`
	font-size: 14px;
`
export const DateSection = styled.div`
	display: flex;
	flex-direction: column;
`

export const DateContainer = styled.div`
	display: flex;
	justify-content: space-between;
	border-bottom: 1px #ccc solid;
	gap: 10px;
	background-color: #fff;

	:last-child{
		border-bottom: 0;
	}
`

export const DateContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	background-color: ${Variables.backgrounds.info};
	padding: 5px 0;
	min-width: 100px;
`

export const DateTitle = styled.h3`
	font-size: 26px;
	font-weight: bold;
	color: #FFF;
`

export const DateSubTitle = styled.span<{ $textBold?: boolean}>`
	font-size: 12px;
	color: #FFF;
	font-weight: ${({ $textBold }) => ($textBold ? 700 : 600)};
`

export const TicketPrice = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	flex: 1;
`

export const TicketPriceText = styled.span`
	font-size: 14px;
`

export const SeatsMapContainer = styled.div`
	flex: 1;
	overflow: hidden;
`

export const SeatsMapContentContainer = styled.div`
	margin-top: 40px;
	width: 100%;
	height: 100%;
	position: relative;
	touch-action: none;

	@media (max-width: 768px) {
		margin-top: 0;
	}
`

export const EventSectionDatesFooter = styled.footer`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	background-color: ${Variables.backgrounds.light};
	box-shadow: ${Variables.boxShadows.level1};
	width: 100%;
	padding: 20px 10px;
`

export const EventSeatsMapCaption = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: ${Variables.backgrounds.light};
	width: 100%;
	padding: 10px;
	border-radius: 0 0 8px 8px;
	border-top: 1px solid #f5f5f5;
`

export const MapCaptionContainer = styled.div`
	display: flex;
	justify-content: space-evenly;
	width: 100%;
`

export const MapCaption = styled.div`
	display: flex;
	gap: 6px;
	font-size: 14px;
	align-items: center;
`

export const MapCaptionCircle =  styled.div<{$color: string}>`
	width: 14px;
	height: 14px;
	border-radius: 50%;
	background-color: ${({ $color }) => $color};
	border: 1px solid #000;
`

export const PurchaseModeSection = styled.div`
	display: flex;
	flex-direction: column;
	padding: 10px;
	gap: 12px;
`

export const PurchaseModeOption = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
	background-color: #fff;
	border-radius: 8px;
	box-shadow: ${Variables.boxShadows.level1};
	padding: 16px;
	cursor: pointer;
`

export const PurchaseModeContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`

export const PurchaseModeTitle = styled.span`
	font-size: 16px;
	font-weight: bold;
`

export const PurchaseModeSubtitle = styled.span`
	font-size: 14px;
	color: #757575;
`

export const LibLoading =  styled.div`
	text-align: center;
	padding: 20px;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center
`
